import Vue from 'vue';
import firebase from "@/plugins/firebase";
import { database } from "@/plugins/firebase";
import store from "@/store";
import _ from "lodash";
import { logActivity } from '@/services/ActivityLogService';
const GradesCollection = 'grades';
export const GradeModule = {
    namespaced: true,
    state: [],
    mutations: {
        store(state, grade) {
            const x = state.find(x => x.id === grade.id);
            if (x) {
                if (_.isEqual(x, grade)) {
                    return;
                }
                state.splice(state.indexOf(x), 1, grade);
                store.dispatch('grade/storeCache');
                return;
            }
            state.push(grade);
            store.dispatch('grade/storeCache');
        },
        update(state, grade) {
            state.find((oldGrade, index) => {
                if (oldGrade.id === grade.id) {
                    Vue.set(state, index, grade);
                }
            });
        },
        destroy(state, grade) {
            const index = state.findIndex(item => grade.id === item.id);
            if (index !== -1) {
                Vue.set(state[index].data, 'deletedAt', grade.data.deletedAt);
            }
        },
        clear(state) {
            state.splice(0, state.length);
        },
    },
    actions: {
        async store(context, grade) {
            // Validate effectiveDate - mandatory field
            const { validateEffectiveDateOrThrow } = await import('@/utils/effectiveDateValidation');
            await validateEffectiveDateOrThrow(grade.data.effectiveDate);
            await database.collection(GradesCollection).add(grade.data);
            // Log activity (fire-and-forget)
            logActivity('CREATE', 'grade', grade.id || 'new', null, grade.data);
        },
        async update(context, grade) {
            // Validate effectiveDate - mandatory field
            const { validateEffectiveDateOrThrow } = await import('@/utils/effectiveDateValidation');
            await validateEffectiveDateOrThrow(grade.data.effectiveDate);
            let document = await database.collection(GradesCollection).doc(grade.id);
            await document.update(grade.data);
            // Log activity (fire-and-forget)
            logActivity('UPDATE', 'grade', grade.id, null, grade.data);
        },
        async destroy(context, grade) {
            // Validate delete is allowed (effectiveDate must be after last concluded work)
            const { validateDeleteOrThrow } = await import('@/utils/effectiveDateValidation');
            await validateDeleteOrThrow(grade.data.effectiveDate);
            // Log activity (fire-and-forget)
            logActivity('DELETE', 'grade', grade.id, grade.data, null);
            // Soft delete - set timestamp
            grade.data.deletedAt = firebase.firestore.Timestamp.now();
            // Update document (not delete)
            const doc = database.collection(GradesCollection).doc(grade.id);
            await doc.update({ deletedAt: grade.data.deletedAt });
            // Update local state and cache
            context.commit('destroy', grade);
            context.dispatch('storeCache');
        },
        async listen(context) {
            context.commit('clear');
            //await context.dispatch('loadCache');
            return database.collection(GradesCollection).onSnapshot(snapshot => {
                for (let change of snapshot.docChanges()) {
                    switch (change.type) {
                        case 'added':
                            context.commit('store', { id: change.doc.id, data: change.doc.data() });
                            break;
                        case 'modified':
                            context.commit('update', { id: change.doc.id, data: change.doc.data() });
                            context.dispatch('storeCache');
                            break;
                        case 'removed':
                            context.commit('destroy', { id: change.doc.id, data: change.doc.data() });
                            context.dispatch('storeCache');
                            break;
                    }
                }
            });
        },
        async storeCache(context) {
            localStorage.removeItem(GradesCollection);
            try {
                localStorage.setItem(GradesCollection, JSON.stringify(context.state));
            }
            catch (e) { /* localStorage quota exceeded or unavailable - non-critical */ }
        },
        async loadCache(context) {
            const cache = localStorage.getItem(GradesCollection);
            if (!cache) {
                return;
            }
            const grades = JSON.parse(cache);
            for (const grade of grades) {
                context.commit('store', { id: grade.id, data: grade.data });
            }
        },
    },
    getters: {
        // Active entities only (for selection dropdowns) - deletedAt is null, undefined, or missing
        active(state) {
            return state.filter(g => !g.data.deletedAt);
        },
        // All entities including deleted (for historical views)
        all(state) {
            return state;
        },
        // Deleted entities only (for admin filter)
        deleted(state) {
            return state.filter(g => !!g.data.deletedAt);
        },
        // Active first, then deleted (for management list per FR-010)
        allSortedForManagement(state) {
            const active = state.filter(g => !g.data.deletedAt);
            const deleted = state.filter(g => !!g.data.deletedAt);
            return [...active, ...deleted];
        }
    }
};
